<template>
  <nav>
    <div class="container_w clear">
      <ul class="clear">
          <router-link to="/" tag="li"><a href="javascript:;">Home</a></router-link>
          <router-link to="/bookflight" tag="li">
            <a href="javascript:;">Book a Flight</a>
              <!-- <nav-list class="nav_list_box"></nav-list> -->
          </router-link>
        <router-link :to="{path:'/prepareflighttext',query: {filetitle: prepareForFlightData.title, filetext: prepareForFlightData.fileText}}" tag="li">
          <a href="javascript:;">Preparing for Flight</a>
          <!-- <nav-list class="nav_list_box"></nav-list> -->
        </router-link>
<!--          <li>-->

<!--            <a href="javascript:;">Preparing for Flight</a>-->
<!--            <nav-list class="nav_list_box" :navState="1"></nav-list>-->
<!--          </li>-->
          <!-- <router-link to="/specialoffer" tag="li"> -->
          <li>
            <a href="javascript:;">Special Offer</a>
              <nav-list class="nav_list_box" :navState="2" :offerData='offerData'></nav-list>
          </li>

          <!-- </router-link> -->
          <li>
            <a href="javascript:;">Information</a>
              <nav-list class="nav_list_box" :navState="3" :informationData='informationData'></nav-list>
          </li>
          <!-- <router-link to="/information" tag="li">
          <a href="javascript:;">Information</a>
              <nav-list class="nav_list_box" :navState="3" :informationData='informationData'></nav-list>
          </router-link> -->
          <!-- <router-link to="/Goldenpandaclub" tag="li">
          <a href="javascript:;">Golden Panda Club</a>
              <nav-list class="nav_list_box" :navState="4"></nav-list>
          </router-link> -->
      </ul>
    </div>
  </nav>
</template>

<script>
import NavList from './NavList';
export default {
  components: {
    NavList
  },
  name: "Nav",
  data() {
    return {
      offerData:[],
      informationData:[],
      prepareForFlightData: {},
    };
  },
  props: {},
  watch: {},
  methods: {
    checkdata(detailObjs){
      debugger
      let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
      this.OfficeID = OfficeID
      var returnDetailObjs = detailObjs.concat();
      // returnDetailObjs.forEach((i,k)=>{
      //   if(i.officeIdStr){
      //     if(i.officeIdStr.indexOf(OfficeID) == -1){
      //       detailObjs.splice(k, 1);
      //     }else{
      //       if(i.childrens){
      //         i.childrens.forEach((i1,k1)=>{
      //           if(i1.officeIdStr){
      //             if(i1.officeIdStr.indexOf(OfficeID) == -1){
      //               i.childrens.splice(k1, 1);
      //             }else{
      //               if(i1.childrens){
      //                 // k2
      //                 i1.childrens.forEach((i2,k2)=>{
      //                   if(i2.officeIdStr){
      //                     if(i2.officeIdStr.indexOf(OfficeID) == -1){
      //                       i1.childrens.splice(k2, 1);
      //                     }else{
      //                       // k3
      //                       if(i2.childrens){
      //                         i2.childrens.forEach((i3,k3)=>{
      //                           if(i3.officeIdStr){
      //                             if(i3.officeIdStr.indexOf(OfficeID) == -1){
      //                               i2.childrens.splice(k3, 1);
      //                             }
      //                           }else{
      //                             i2.childrens.splice(k3, 1);
      //                           }
      //                         })
      //                       }
      //                     }
      //                   }else{
      //                      i1.childrens.splice(k2, 1);
      //                   }
      //                 })
      //               }
      //             }
      //           }else{
      //             i.childrens.splice(k1, 1);
      //           }
      //         })
      //       }
      //     }
      //   }else{
      //     returnDetailObjs.splice(k, 1);
      //   }
      // })

        for (var i = 0; i < returnDetailObjs.length; i++) {
            if(returnDetailObjs[i].officeIdStr){
              if(returnDetailObjs[i].officeIdStr.indexOf(OfficeID) == -1){
                returnDetailObjs.splice(i--, 1);
              }else{

                if(returnDetailObjs[i].childrens){
                  for(var j=0;j<returnDetailObjs[i].childrens.length;j++){
                    if(returnDetailObjs[i].childrens[j].officeIdStr){
                      if(returnDetailObjs[i].childrens[j].officeIdStr.indexOf(OfficeID) == -1){
                        returnDetailObjs[i].childrens.splice(j--, 1);
                      }else{

                        if(returnDetailObjs[i].childrens[j].childrens){

                          for(var k = 0;k<returnDetailObjs[i].childrens[j].childrens.length;k++){
                            if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr){
                              if(returnDetailObjs[i].childrens[j].childrens[k].officeIdStr.indexOf(OfficeID) == -1){
                                returnDetailObjs[i].childrens[j].childrens.splice(k--, 1);
                              }
                            }
                          }
                        }
                      }
                    }else{
                      // 值null全部处理
                      returnDetailObjs[i].childrens.splice(j--, 1);
                    }
                  }
                }
              }
            }else{
              // 值null全部处理
              returnDetailObjs.splice(i--, 1);
            }

        }
        return returnDetailObjs;
    }
  },
  filters: {},
  computed: {},
  created() {
    let prepareForFlightList = []
    let officelist = []
    let informationlist = []
    NAVJSON[0].childrens.forEach((i)=>{
      if (i.nodeTitle == 'Prepare for Flight') {
        prepareForFlightList.push(i)
      } else if (i.nodeTitle == 'Special Offer'){
        officelist.push(i)
      } else if (i.nodeTitle == 'Information'){
        informationlist.push(i)
      }
    })

      if (prepareForFlightList && prepareForFlightList.length) {
        this.$Utils.setSession('prepareForFlightList', prepareForFlightList)
        this.prepareForFlightData = prepareForFlightList[0].childrens ? prepareForFlightList[0].childrens[0] : {}
      }
      if (officelist && officelist.length) {
          this.offerData = officelist[0].childrens || []
      }
      if (informationlist && informationlist.length) {
          console.log(informationlist)
          try {
              let newData = this.checkdata(informationlist[0].childrens)
              informationlist[0].childrens = newData
              console.log(informationlist[0].childrens,'navlist=========',newData)
              this.$Utils.setSession('informationData',informationlist)
              this.informationData = informationlist[0].childrens
          } catch (e) {
              console.log(e, '========err========')
          }
      }
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
nav{
    background: #D8000F;
    ul{
      position: relative;
        li{
            font-size:18px;
            color:rgba(255,255,255,1);
            a{
              color: #fff;
              height: 80px;
              line-height: 80px;
              float: left;
              padding: 0 32px;

            }
            cursor: pointer;
            .nav_list_box{
              display: none;
              position: absolute;
              top: 80px;
              left: 0;
              z-index: 99;
              background: #fff;
              box-shadow:0px 6px 8px 0px rgba(0,0,0,0.1);
              border:1px solid rgba(236,238,240,1);
            }
            &:hover{
                a{
                  background: #C2000D;
                }
                .nav_list_box{
                  display: block;
                  cursor:default;
                }
            }
        }
    }
}

</style>
